import { useQuery } from '@tanstack/react-query';
import invariant from 'tiny-invariant';

import { Search } from '@air/api';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

const getPrivateCitiesListKey = ({
  workspaceId,
  search,
  boardId,
  libraryId,
}: {
  workspaceId: string | undefined;
  search: string;
  boardId: string | undefined;
  libraryId: string | undefined;
}) => ['PRIVATE_CITIES', { workspaceId, search, boardId, libraryId }];

export const usePrivateCitiesList = ({
  search,
  boardId,
  libraryId,
}: {
  search: string;
  boardId: string | undefined;
  libraryId: string | undefined;
}) => {
  const { currentWorkspace } = useCurrentWorkspace();

  const key = getPrivateCitiesListKey({ workspaceId: currentWorkspace?.id, search, boardId, libraryId });

  return useQuery({
    queryKey: key,

    queryFn: async () => {
      invariant(currentWorkspace?.id, 'Workspace ID is required');

      const data = await Search.getAssetVersionFilterLookups({
        limit: 20,
        workspaceId: currentWorkspace.id,
        field: 'location.city',
        boardId,
        search,
        libraryId,
      });

      return data.lookups.map(({ value }) => value.toString());
    },
    enabled: !!currentWorkspace?.id,
  });
};
